import React from "react";
// import FreeSpinIntroDialog from "../FreeSpinIntroDialog/FreeSpinIntroDialog";
// import FreeSpinOutroDialog from "../FreeSpinOutroDialog/FreeSpinOutroDialog";
// import FreeSpinRetriggerDialog from "../FreeSpinRetriggerDialog/FreeSpinRetriggerDialog";
// import { FEATURES_CONFIG } from "../../../featuresConfig";
import HoldAndWinIntroDialog from "../HoldAndWinIntroDialog/HoldAndWinIntroDialog";
import HoldAndWinOutroDialog from "../HoldAndWinOutroDialog/HoldAndWinOutroDialog";
import MaxWinDialog from "../MaxWinDialog/MaxWinDialog";

const Dialogs = () => {
  return (
    <>
      <HoldAndWinIntroDialog />
      <HoldAndWinOutroDialog />
      <MaxWinDialog />
      {/* {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinIntroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinOutroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinRetriggerDialog />} */}
    </>
  );
};

export default Dialogs;
